import { connect } from 'react-redux';
import FinalFiles from 'project/components/wrapup/final_files';
import { getProject } from 'project/ducks/project';
import { getSubCategory } from 'common/ducks/categories';
import { fetchMessagesIfNeeded } from 'common/ducks/message';
import { getProjectUrl } from 'project/utils';
import { getPrepopulatedWrapupMsgOpts } from 'admin/utils';

const mapStateToProps = (state, { wrapup }) => {
  const project = state.admin.projects.currentProject || getProject(state);
  const subCategory = getSubCategory(state.categories, project.sub_category);
  const projectUrl = getProjectUrl(project, subCategory.slug);
  const user = state.user.profile_data;

  return {
    projectUrl,
    user,
    acceptedFormats: subCategory.deliverables,
    approveChecklist: subCategory.client_approve_final_files_checklist,
    itemsToUpload: subCategory.creative_submit_final_files_checklist,
    prepopulatedMsgOpts: getPrepopulatedWrapupMsgOpts({ user, project, wrapup, step: "final_files" })
  };
};

export default connect(mapStateToProps, {
  fetchMessagesIfNeeded
})(FinalFiles);



// WEBPACK FOOTER //
// ./project/containers/wrapup/final_files.js